module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main